import type { CompanyAssessmentQuestionDto } from "@/dto";
import type { PropType } from "vue";

export const companyAssessmentInputProps = {
	question: {
		type: Object as PropType<CompanyAssessmentQuestionDto>,
		required: true,
	},

	language: {
		type: String,
		required: true,
	},

	displayMode: {
		type: Boolean as PropType<boolean>,
		default: false,
	},
} as const;
